<template>
    <div>
        <h5>Selected Music</h5>
        <playlist-summary
            ref="selectedSummary"
            :token="token"
            :disableDragDrop="disableDragDrop"
            :itemBaseId="'playlist-selected'"
            :displaySelectionCountWarning="false"
            @refresh-sync="$emit('refresh-sync')"
            @playing="handlePlaylistPlaying('selectedSummary')"
        />

        <v-divider></v-divider>
        <div v-if="showCopyrightPlaylist">
            <h5>
                Public Playlist

                <custom-tooltip class="d-inline-block" :tooltipProps="{ top: true, maxWidth: 400 }">
                    <template #activator>
                        <font-awesome-icon class="mr-1" icon="fa-regular fa-circle-info"></font-awesome-icon>
                    </template>

                    <template #content>
                        <p class="p-0 m-0">
                            <strong style="color: #207361">Public playlists</strong> are auto-generated for
                            <strong style="color: #207361">embedded videos</strong> and can be customized.

                            <strong style="color: #1878f3">Selected music playlists</strong> are used for
                            <strong style="color: #1878f3">private views and downloads</strong>.
                        </p>
                    </template>
                </custom-tooltip>
            </h5>
            <playlist-summary
                ref="copyrightPlaylistSummary"
                :token="token"
                :disableDragDrop="disableDragDrop"
                :itemBaseId="'playlist-copyright-safe'"
                copyright-safe
                @refresh-sync="$emit('refresh-sync')"
                @playing="handlePlaylistPlaying('copyrightPlaylistSummary')"
            />
            <v-divider></v-divider>
        </div>
    </div>
</template>
<script>
import PlaylistSummary from '@/components/ManageService/Tribute/PlaylistSummary';
import CustomTooltip from '@/components/ui/CustomTooltip.vue';
export default {
    data() {
        return {};
    },
    methods: {
        handlePlaylistPlaying(playlistName) {
            var playlistRef = null;

            if (playlistName == 'selectedSummary') {
                playlistRef = this.$refs.copyrightPlaylistSummary;
            } else {
                playlistRef = this.$refs.selectedSummary;
            }

            if (playlistRef && typeof playlistRef.stopAllAudio === 'function') {
                playlistRef.stopAllAudio();
            }
        },
        refreshCopyrightPlaylist() {
            if (this.$refs.copyrightPlaylistSummary) {
                this.$refs.copyrightPlaylistSummary.refresh();
            }
        },
    },
    props: {
        token: {
            type: String,
            required: true,
        },
        disableDragDrop: {
            type: Boolean,
            default: false,
        },
        showCopyrightPlaylist: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        PlaylistSummary,
        CustomTooltip,
    },
};
</script>
<style lang=""></style>
